import store from 'redux/config'
import {RouterStates} from 'router/states/routerStates.enum'
import {TransitionHookType} from 'commonTypes'
import {fetchDatabases} from 'redux/databases/databases.duck'
import {select_gridSession} from '../../redux/databases/selectors'
import {DatabasesGridSessionAC} from '../../redux/databases/gridSession.duck'

const {dispatch} = store

export const getDatabasesHook: TransitionHookType = {
  criteria: {
    to: state => state?.name === RouterStates.databases,
  },
  callback: transition => {
    const {filters} = transition.params()

    const gridSession = select_gridSession(store.getState())

    const shouldUsePrevStateValue = (filters.searchQuery === '') && (gridSession.filters.searchQuery !== '')
    shouldUsePrevStateValue ? dispatch(DatabasesGridSessionAC.filtersApplied(gridSession.filters)) : dispatch(DatabasesGridSessionAC.filtersApplied(filters))

    dispatch(fetchDatabases())
  },
}
